import React, { useEffect, useState } from "react";
import {connect, useSelector} from "react-redux";
import {bindActionCreators} from "redux";
import {useParams} from "react-router-dom";
import {
    Paper,
    Typography,
    Box,
    Modal,
    TextField,
    Button,
    Table,
    TableHead,
    TableContainer,
    TableRow,
    TableCell,
    TableBody,
    IconButton,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Tooltip,
} from "@mui/material";
import AddBoxIcon from '@mui/icons-material/AddBox';
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import EditIcon from '@mui/icons-material/Edit';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import groupsActions from '../../../store/group/actions';
import organisationActions from '../../../store/organisation/actions';
import {selectGroupById, selectGroupCourses, selectNotInGroupCourses} from '../../../store/group/selectors';
import {CommonState} from "../../../store";
import {IGroup} from "../../../common/group";
import {selectUserOrganisation} from "../../../store/user/selectors";
import {IOrganisation, IOrganisationUser} from "../../../common/organisation";
import {selectOrganisationUsersInGroup, selectOrganisationUsersOutsideOfGroup} from "../../../store/organisation/selectots";
import {addGroupUser} from "../../../store/group/sagas";
import courseActions from '../../../store/course/actions';
import {Course} from "../../../common/course";

type Props = {
    fetchGroups: Function;
    editGroup: Function;
    fetchProfiles: Function;
    organisation: IOrganisation;
    fetchCourses: Function;
    deleteGroupUser: Function;
    addGroupUser: Function;
    fetchAllCourses: Function;
    addGroupCourse: Function;
    deleteGroupCourse: Function;
}
const USER_TABLE_CELLS = [
    '№',
    'Имя',
    'Логин',
    'Email',
    '',
];

const COURSE_TABLE_CELLS = [
    'Название Курса',
    '',
]
const View = ({
    fetchGroups,
    editGroup,
    fetchProfiles,
    organisation,
    fetchCourses,
    deleteGroupUser,
    addGroupUser,
    fetchAllCourses,
    addGroupCourse,
    deleteGroupCourse,
}: Props) => {
    const {groupId} = useParams();
    const group = useSelector((state: CommonState) => selectGroupById(state, groupId as IGroup['id']));
    const courses = useSelector((state: CommonState) => selectGroupCourses(state, {groupId: String(groupId)}));
    const coursesNotInGroup = useSelector((state: CommonState) => selectNotInGroupCourses(state, {groupId: String(groupId)}));
    const [newName, setNewName] = useState<string>();
    const [userToDelete, setUserToDelete] = useState<string>();
    //'bc5de078-0272-4b16-ae1e-5c4483e121da'
    const [courseToAdd, setCourseToAdd] = useState<Course['id']>();
    const [addUserModalOpen, setUserModalVisibility] = useState<boolean>();
    const [addCourseModalOpen, setCourseModalVisibility] = useState<boolean>();
    const [newUserInGroup, setNewUser] = useState<IOrganisationUser>();
    const usersInGroup = useSelector((state: CommonState)=> (
        groupId && organisation?.alias ? selectOrganisationUsersInGroup(state, {groupId, alias: organisation.alias})
        : []
    ));
    const usersOutsideOfGroup = useSelector((state: CommonState) => (
        groupId && organisation?.alias ? selectOrganisationUsersOutsideOfGroup(state, {groupId, alias: organisation.alias})
        : []
    ));
    const handleDeleteUser = (deleteUser?: Boolean) => {
        if (userToDelete && deleteUser) {
            deleteGroupUser({id: groupId, userId: userToDelete});
        }
        setUserToDelete(undefined);
    };
    const handleAddUser = (saveUser?: boolean) => {
        if (saveUser && newUserInGroup) { 
           addGroupUser({id: groupId, userId: newUserInGroup.id});
        }
        setNewUser(undefined);
        setUserModalVisibility(false);
    };
    const handleAddCourse = (saveCourse?: boolean) => { 
        if (saveCourse && courseToAdd) {
            addGroupCourse({id: groupId, courseId: courseToAdd});
        }
        setCourseModalVisibility(false);
    }
    const handleGroupModalClose = (saveGroup: boolean) => {
        if (saveGroup && newName !== group?.name) {
            editGroup({id: group?.id, newName});
        }
        setNewName(undefined);
    }
    useEffect(() => {
        fetchGroups();
        fetchCourses(groupId);
        fetchAllCourses();
    }, []);
    useEffect(() => {
        if (organisation && !organisation.users?.length) {
            fetchProfiles(organisation.alias)
        }
    }, [organisation])
    if (!group) {
        return null;
    }
    return (
        <>
            <Paper sx={{p: 2}}>
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        mb: 4,
                    }}
                >
                    <Typography
                        component='h2'
                        sx={{
                            fontWeight: 'bold',
                            fontSize: '1.5rem',
                            color: '#507ebc',
                        }}
                    >
                        {group.name}
                    </Typography>
                    <Tooltip title="Переименовать группу">
                        <IconButton color='primary' sx={{ml: 2}} size='large' onClick={() => {setNewName(group.name)}}>
                            <EditIcon color='primary' />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="Добавить пользователя">
                        <IconButton
                            color='primary'
                            size='large'
                            onClick={() => {
                                setUserModalVisibility(true);
                                setNewUser(usersOutsideOfGroup[0]);
                            }}
                        >
                        <PersonAddAltIcon color='primary' />
                    </IconButton>
                    </Tooltip>
                    <Tooltip title="Добавить курс">
                        <IconButton color='primary' size='large' onClick={() => setCourseModalVisibility(true)}>
                            <AddBoxIcon color='primary'/>
                        </IconButton>
                    </Tooltip>
                </Box>
                <Typography
                        component='h2'
                        sx={{
                            fontWeight: 'bold',
                            fontSize: '1rem',
                            color: '#507ebc',
                        }}
                    >
                    Участники
                </Typography>
                <TableContainer component={Box} sx={{mb: 4}}>
                    <Table
                        sx={{minWidth: '200px'}}
                    >
                        <TableHead>
                            <TableRow>
                               {USER_TABLE_CELLS.map((cell) => (
                                <TableCell key={cell}>{cell}</TableCell>
                               ))} 
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {usersInGroup?.map((user: IOrganisationUser, index: number) => (
                                <TableRow key={user.login}>
                                     <TableCell>{index+1}</TableCell>
                                    <TableCell>{user.name}</TableCell>
                                    <TableCell>{user.login}</TableCell>
                                    <TableCell>{user.email || ''}</TableCell>
                                    <TableCell>
                                        <IconButton color='primary' size='large' onClick={() => setUserToDelete(user.id)}>
                                            <DeleteForeverIcon color='primary' />
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                {courses?.length && (<Typography
                        component='h2'
                        sx={{
                            fontWeight: 'bold',
                            fontSize: '1rem',
                            color: '#507ebc',
                        }}
                    >
                    Курсы
                </Typography>)}
                {courses?.length && (
                    <TableContainer component={Box}>
                    <Table sx={{minWidth: '200px'}}>
                        <TableHead>
                            <TableRow>
                               {COURSE_TABLE_CELLS.map((cell) => (
                                <TableCell key={cell}>{cell}</TableCell>
                               ))} 
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {courses?.map(course => (
                                <TableRow key={course.id}>
                                    <TableCell>{course.title}</TableCell>
                                    <TableCell align="center">
                                        <IconButton color='primary' size='large' onClick={() => deleteGroupCourse({id: groupId, courseId: course.id})}>
                                            <DeleteForeverIcon color='primary' />
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                )}
            </Paper>
            <Modal open={Boolean(newName)} onClose={() => handleGroupModalClose(false)}>
                <Box sx={{
                        backgroundColor: '#fff',
                        width: '280px',
                        p: 4,
                        borderRadius: 1,
                        top: '50%',
                        left: '50%',
                        position: 'absolute',
                        transform: 'translate(-50%, -50%)',
                    }}>
                        <TextField
                            type='text'
                            placeholder='Имя группы'
                            defaultValue={newName}
                            onChange={e => setNewName(e.target.value)}
                            fullWidth
                        />
                        <Button
                            variant="contained"
                            sx={{
                                marginX: 'auto',
                                display: 'block',
                                marginTop: 2,
                                width: '100%',
                                p: 2
                            }}
                            onClick={() => handleGroupModalClose(true)}
                        >
                            Переименовать Группу
                        </Button>
                    </Box>
            </Modal>
            <Modal open={Boolean(userToDelete)} onClose={() => handleDeleteUser(false)}>
                <Box sx={{
                        backgroundColor: '#fff',
                        width: '280px',
                        p: 4,
                        borderRadius: 1,
                        top: '50%',
                        left: '50%',
                        position: 'absolute',
                        transform: 'translate(-50%, -50%)',
                    }}>
                        <Typography
                            component='h2'
                            sx={{
                                fontWeight: 'bold',
                                fontSize: '1rem',
                                color: '#507ebc',
                            }}
                        >
                            Вы точно хотите удалить пользователя из группы?
                        </Typography>
                        <Button
                            variant="contained"
                            sx={{
                                marginX: 'auto',
                                display: 'block',
                                marginTop: 2,
                                width: '100%',
                                p: 2
                            }}
                            onClick={() =>  handleDeleteUser(true)}
                        >
                          Да 
                        </Button>
                        <Button
                            variant="contained"
                            sx={{
                                marginX: 'auto',
                                display: 'block',
                                marginTop: 2,
                                width: '100%',
                                p: 2,
                                backgroundColor: 'error.main',
                            }}
                            onClick={() =>  handleDeleteUser()}
                        >
                          Нет
                        </Button>
                    </Box>
            </Modal>
            <Modal open={Boolean(addUserModalOpen)} onClose={() => handleAddUser()}>
                <Box sx={{
                        backgroundColor: '#fff',
                        width: '280px',
                        p: 4,
                        borderRadius: 1,
                        top: '50%',
                        left: '50%',
                        position: 'absolute',
                        transform: 'translate(-50%, -50%)',
                    }}>
                        <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">Добавить пользователя</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={newUserInGroup?.id || usersOutsideOfGroup[0]?.id}
                                label=""
                                onChange={(e) => {setNewUser(usersOutsideOfGroup.find((user: IOrganisationUser)=> user.id === e.target.value))}}
                            >
                                {usersOutsideOfGroup.map((user: IOrganisationUser) => (
                                    <MenuItem key={user.id} value={user.id}>{user.name}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <Box sx={{mt: 4, display: 'flex', justifyContent: 'flex-start'}}>
                            <Button
                                variant="contained"
                                sx={{
                                    display: 'block',
                                    p: 2
                                }}
                                onClick={() =>  handleAddUser(true)}
                            >
                            Сохранить
                            </Button>
                            <Button
                                variant="contained"
                                sx={{
                                    display: 'block',
                                    marginLeft: 2,
                                    p: 2,
                                    backgroundColor: 'error.main',
                                }}
                                onClick={() =>  handleAddUser()}
                            >
                            Отмена
                            </Button>
                        </Box>
                    </Box>
            </Modal>
            <Modal open={Boolean(addCourseModalOpen)} onClose={() => handleAddCourse()}>
                <Box sx={{
                        backgroundColor: '#fff',
                        width: '280px',
                        p: 4,
                        borderRadius: 1,
                        top: '50%',
                        left: '50%',
                        position: 'absolute',
                        transform: 'translate(-50%, -50%)',
                    }}>
                        <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">Добавить Курс</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                label=""
                                onChange={(e) => setCourseToAdd(String(e.target.value))}
                            >
                                {coursesNotInGroup.map((course: Course) => (
                                    <MenuItem key={course.id} value={course.id}>{course.title}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <Box sx={{mt: 4, display: 'flex', justifyContent: 'flex-start'}}>
                            <Button
                                variant="contained"
                                sx={{
                                    display: 'block',
                                    p: 2
                                }}
                                onClick={() =>  handleAddCourse(true)}
                            >
                            Сохранить
                            </Button>
                            <Button
                                variant="contained"
                                sx={{
                                    display: 'block',
                                    marginLeft: 2,
                                    p: 2,
                                    backgroundColor: 'error.main',
                                }}
                                onClick={() =>  handleAddCourse()}
                            >
                            Отмена
                            </Button>
                        </Box>
                    </Box>
            </Modal>
        </>
    );
}

//@ts-expect-error
const mapStateToProps = (state) => ({
    organisation: selectUserOrganisation(state),
})

//@ts-expect-error
const dispatchProps = (dispatch) => ({
    fetchGroups: bindActionCreators(groupsActions.fetchGroups, dispatch),
    editGroup: bindActionCreators(groupsActions.editGroup, dispatch),
    fetchProfiles: bindActionCreators(organisationActions.getOrganisationProfiles, dispatch),
    fetchCourses: bindActionCreators(groupsActions.getGroupCourses, dispatch),
    deleteGroupUser: bindActionCreators(groupsActions.deleteGroupUser, dispatch),
    addGroupUser: bindActionCreators(groupsActions.addGroupUser, dispatch),
    fetchAllCourses: bindActionCreators(courseActions.fetchCourses, dispatch),
    addGroupCourse: bindActionCreators(groupsActions.addGroupCourse, dispatch),
    deleteGroupCourse: bindActionCreators(groupsActions.deleteGroupCourse, dispatch),
})


export default connect(mapStateToProps, dispatchProps)(View);